/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as GamesAuthenticatedRouteImport } from './routes/games/_authenticated'
import { Route as DashboardSigninRouteImport } from './routes/_dashboard/signin'
import { Route as DashboardLearnRouteImport } from './routes/_dashboard/learn'
import { Route as DashboardFeaturesRouteImport } from './routes/_dashboard/features'
import { Route as DashboardAuthenticatedRouteImport } from './routes/_dashboard/_authenticated'
import { Route as DashboardAuthenticatedGamesIndexRouteImport } from './routes/_dashboard/_authenticated.games/index'
import { Route as DashboardAuthenticatedGamesLobbyIdRouteImport } from './routes/_dashboard/_authenticated.games/lobby.$id'

const GamesAuthenticatedIdLazyRouteImport = createFileRoute(
  '/games/_authenticated/$id',
)()
const GamesAuthenticatedIdTurnReportsLazyRouteImport = createFileRoute(
  '/games/_authenticated/$id/turn-reports',
)()
const GamesAuthenticatedIdShipDesignsLazyRouteImport = createFileRoute(
  '/games/_authenticated/$id/ship-designs',
)()
const GamesAuthenticatedIdResearchLazyRouteImport = createFileRoute(
  '/games/_authenticated/$id/research',
)()
const GamesAuthenticatedIdDilemmasIndexLazyRouteImport = createFileRoute(
  '/games/_authenticated/$id/dilemmas/',
)()
const GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteImport =
  createFileRoute('/games/_authenticated/$id/star-system/$starSystemId')()
const GamesAuthenticatedIdShipDesignsNewLazyRouteImport = createFileRoute(
  '/games/_authenticated/$id/ship-designs/new',
)()
const GamesAuthenticatedIdEngagementEngagementIdLazyRouteImport =
  createFileRoute('/games/_authenticated/$id/engagement/$engagementId')()
const GamesAuthenticatedIdDilemmasDilemmaIdLazyRouteImport = createFileRoute(
  '/games/_authenticated/$id/dilemmas/$dilemmaId',
)()
const GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteImport =
  createFileRoute(
    '/games/_authenticated/$id/star-system/$starSystemId/task-forces',
  )()
const GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRouteImport =
  createFileRoute(
    '/games/_authenticated/$id/star-system/$starSystemId/industrial-projects',
  )()
const GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRouteImport =
  createFileRoute(
    '/games/_authenticated/$id/star-system/$starSystemId/commission-task-force',
  )()
const GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRouteImport =
  createFileRoute(
    '/games/_authenticated/$id/star-system/$starSystemId/colonization',
  )()
const GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRouteImport =
  createFileRoute(
    '/games/_authenticated/$id/star-system/$starSystemId/task-forces/$taskForceId',
  )()

const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const GamesAuthenticatedRoute = GamesAuthenticatedRouteImport.update({
  id: '/games/_authenticated',
  path: '/games',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSigninRoute = DashboardSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardLearnRoute = DashboardLearnRouteImport.update({
  id: '/learn',
  path: '/learn',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardFeaturesRoute = DashboardFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAuthenticatedRoute = DashboardAuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => DashboardRoute,
} as any)
const GamesAuthenticatedIdLazyRoute =
  GamesAuthenticatedIdLazyRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => GamesAuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/games/_authenticated.$id.lazy').then((d) => d.Route),
  )
const DashboardAuthenticatedGamesIndexRoute =
  DashboardAuthenticatedGamesIndexRouteImport.update({
    id: '/games/',
    path: '/games/',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)
const GamesAuthenticatedIdTurnReportsLazyRoute =
  GamesAuthenticatedIdTurnReportsLazyRouteImport.update({
    id: '/turn-reports',
    path: '/turn-reports',
    getParentRoute: () => GamesAuthenticatedIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/games/_authenticated.$id/turn-reports.lazy').then(
      (d) => d.Route,
    ),
  )
const GamesAuthenticatedIdShipDesignsLazyRoute =
  GamesAuthenticatedIdShipDesignsLazyRouteImport.update({
    id: '/ship-designs',
    path: '/ship-designs',
    getParentRoute: () => GamesAuthenticatedIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/games/_authenticated.$id/ship-designs.lazy').then(
      (d) => d.Route,
    ),
  )
const GamesAuthenticatedIdResearchLazyRoute =
  GamesAuthenticatedIdResearchLazyRouteImport.update({
    id: '/research',
    path: '/research',
    getParentRoute: () => GamesAuthenticatedIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/games/_authenticated.$id/research.lazy').then(
      (d) => d.Route,
    ),
  )
const GamesAuthenticatedIdDilemmasIndexLazyRoute =
  GamesAuthenticatedIdDilemmasIndexLazyRouteImport.update({
    id: '/dilemmas/',
    path: '/dilemmas/',
    getParentRoute: () => GamesAuthenticatedIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/games/_authenticated.$id/dilemmas.index.lazy').then(
      (d) => d.Route,
    ),
  )
const GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute =
  GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteImport.update({
    id: '/star-system/$starSystemId',
    path: '/star-system/$starSystemId',
    getParentRoute: () => GamesAuthenticatedIdLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/games/_authenticated.$id/star-system.$starSystemId.lazy'
    ).then((d) => d.Route),
  )
const GamesAuthenticatedIdShipDesignsNewLazyRoute =
  GamesAuthenticatedIdShipDesignsNewLazyRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => GamesAuthenticatedIdShipDesignsLazyRoute,
  } as any).lazy(() =>
    import('./routes/games/_authenticated.$id/ship-designs.new.lazy').then(
      (d) => d.Route,
    ),
  )
const GamesAuthenticatedIdEngagementEngagementIdLazyRoute =
  GamesAuthenticatedIdEngagementEngagementIdLazyRouteImport.update({
    id: '/engagement/$engagementId',
    path: '/engagement/$engagementId',
    getParentRoute: () => GamesAuthenticatedIdLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/games/_authenticated.$id/engagement.$engagementId.lazy'
    ).then((d) => d.Route),
  )
const GamesAuthenticatedIdDilemmasDilemmaIdLazyRoute =
  GamesAuthenticatedIdDilemmasDilemmaIdLazyRouteImport.update({
    id: '/dilemmas/$dilemmaId',
    path: '/dilemmas/$dilemmaId',
    getParentRoute: () => GamesAuthenticatedIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/games/_authenticated.$id/dilemmas.$dilemmaId.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardAuthenticatedGamesLobbyIdRoute =
  DashboardAuthenticatedGamesLobbyIdRouteImport.update({
    id: '/games/lobby/$id',
    path: '/games/lobby/$id',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)
const GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRoute =
  GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteImport.update({
    id: '/task-forces',
    path: '/task-forces',
    getParentRoute: () => GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/games/_authenticated.$id/star-system.$starSystemId.task-forces.lazy'
    ).then((d) => d.Route),
  )
const GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRoute =
  GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRouteImport.update(
    {
      id: '/industrial-projects',
      path: '/industrial-projects',
      getParentRoute: () => GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/games/_authenticated.$id/star-system.$starSystemId.industrial-projects.lazy'
    ).then((d) => d.Route),
  )
const GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRoute =
  GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRouteImport.update(
    {
      id: '/commission-task-force',
      path: '/commission-task-force',
      getParentRoute: () => GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/games/_authenticated.$id/star-system.$starSystemId.commission-task-force.lazy'
    ).then((d) => d.Route),
  )
const GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRoute =
  GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRouteImport.update({
    id: '/colonization',
    path: '/colonization',
    getParentRoute: () => GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/games/_authenticated.$id/star-system.$starSystemId.colonization.lazy'
    ).then((d) => d.Route),
  )
const GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRoute =
  GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRouteImport.update(
    {
      id: '/$taskForceId',
      path: '/$taskForceId',
      getParentRoute: () =>
        GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/games/_authenticated.$id/star-system.$starSystemId.task-forces.$taskForceId.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof DashboardIndexRoute
  '/features': typeof DashboardFeaturesRoute
  '/learn': typeof DashboardLearnRoute
  '/signin': typeof DashboardSigninRoute
  '/games': typeof GamesAuthenticatedRouteWithChildren
  '/games/$id': typeof GamesAuthenticatedIdLazyRouteWithChildren
  '/games/$id/research': typeof GamesAuthenticatedIdResearchLazyRoute
  '/games/$id/ship-designs': typeof GamesAuthenticatedIdShipDesignsLazyRouteWithChildren
  '/games/$id/turn-reports': typeof GamesAuthenticatedIdTurnReportsLazyRoute
  '/games/': typeof DashboardAuthenticatedGamesIndexRoute
  '/games/lobby/$id': typeof DashboardAuthenticatedGamesLobbyIdRoute
  '/games/$id/dilemmas/$dilemmaId': typeof GamesAuthenticatedIdDilemmasDilemmaIdLazyRoute
  '/games/$id/engagement/$engagementId': typeof GamesAuthenticatedIdEngagementEngagementIdLazyRoute
  '/games/$id/ship-designs/new': typeof GamesAuthenticatedIdShipDesignsNewLazyRoute
  '/games/$id/star-system/$starSystemId': typeof GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteWithChildren
  '/games/$id/dilemmas/': typeof GamesAuthenticatedIdDilemmasIndexLazyRoute
  '/games/$id/star-system/$starSystemId/colonization': typeof GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRoute
  '/games/$id/star-system/$starSystemId/commission-task-force': typeof GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRoute
  '/games/$id/star-system/$starSystemId/industrial-projects': typeof GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRoute
  '/games/$id/star-system/$starSystemId/task-forces': typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteWithChildren
  '/games/$id/star-system/$starSystemId/task-forces/$taskForceId': typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof DashboardIndexRoute
  '/features': typeof DashboardFeaturesRoute
  '/learn': typeof DashboardLearnRoute
  '/signin': typeof DashboardSigninRoute
  '/games': typeof DashboardAuthenticatedGamesIndexRoute
  '/games/$id': typeof GamesAuthenticatedIdLazyRouteWithChildren
  '/games/$id/research': typeof GamesAuthenticatedIdResearchLazyRoute
  '/games/$id/ship-designs': typeof GamesAuthenticatedIdShipDesignsLazyRouteWithChildren
  '/games/$id/turn-reports': typeof GamesAuthenticatedIdTurnReportsLazyRoute
  '/games/lobby/$id': typeof DashboardAuthenticatedGamesLobbyIdRoute
  '/games/$id/dilemmas/$dilemmaId': typeof GamesAuthenticatedIdDilemmasDilemmaIdLazyRoute
  '/games/$id/engagement/$engagementId': typeof GamesAuthenticatedIdEngagementEngagementIdLazyRoute
  '/games/$id/ship-designs/new': typeof GamesAuthenticatedIdShipDesignsNewLazyRoute
  '/games/$id/star-system/$starSystemId': typeof GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteWithChildren
  '/games/$id/dilemmas': typeof GamesAuthenticatedIdDilemmasIndexLazyRoute
  '/games/$id/star-system/$starSystemId/colonization': typeof GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRoute
  '/games/$id/star-system/$starSystemId/commission-task-force': typeof GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRoute
  '/games/$id/star-system/$starSystemId/industrial-projects': typeof GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRoute
  '/games/$id/star-system/$starSystemId/task-forces': typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteWithChildren
  '/games/$id/star-system/$starSystemId/task-forces/$taskForceId': typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_dashboard/_authenticated': typeof DashboardAuthenticatedRouteWithChildren
  '/_dashboard/features': typeof DashboardFeaturesRoute
  '/_dashboard/learn': typeof DashboardLearnRoute
  '/_dashboard/signin': typeof DashboardSigninRoute
  '/games/_authenticated': typeof GamesAuthenticatedRouteWithChildren
  '/_dashboard/': typeof DashboardIndexRoute
  '/games/_authenticated/$id': typeof GamesAuthenticatedIdLazyRouteWithChildren
  '/games/_authenticated/$id/research': typeof GamesAuthenticatedIdResearchLazyRoute
  '/games/_authenticated/$id/ship-designs': typeof GamesAuthenticatedIdShipDesignsLazyRouteWithChildren
  '/games/_authenticated/$id/turn-reports': typeof GamesAuthenticatedIdTurnReportsLazyRoute
  '/_dashboard/_authenticated/games/': typeof DashboardAuthenticatedGamesIndexRoute
  '/_dashboard/_authenticated/games/lobby/$id': typeof DashboardAuthenticatedGamesLobbyIdRoute
  '/games/_authenticated/$id/dilemmas/$dilemmaId': typeof GamesAuthenticatedIdDilemmasDilemmaIdLazyRoute
  '/games/_authenticated/$id/engagement/$engagementId': typeof GamesAuthenticatedIdEngagementEngagementIdLazyRoute
  '/games/_authenticated/$id/ship-designs/new': typeof GamesAuthenticatedIdShipDesignsNewLazyRoute
  '/games/_authenticated/$id/star-system/$starSystemId': typeof GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteWithChildren
  '/games/_authenticated/$id/dilemmas/': typeof GamesAuthenticatedIdDilemmasIndexLazyRoute
  '/games/_authenticated/$id/star-system/$starSystemId/colonization': typeof GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRoute
  '/games/_authenticated/$id/star-system/$starSystemId/commission-task-force': typeof GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRoute
  '/games/_authenticated/$id/star-system/$starSystemId/industrial-projects': typeof GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRoute
  '/games/_authenticated/$id/star-system/$starSystemId/task-forces': typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteWithChildren
  '/games/_authenticated/$id/star-system/$starSystemId/task-forces/$taskForceId': typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/features'
    | '/learn'
    | '/signin'
    | '/games'
    | '/games/$id'
    | '/games/$id/research'
    | '/games/$id/ship-designs'
    | '/games/$id/turn-reports'
    | '/games/'
    | '/games/lobby/$id'
    | '/games/$id/dilemmas/$dilemmaId'
    | '/games/$id/engagement/$engagementId'
    | '/games/$id/ship-designs/new'
    | '/games/$id/star-system/$starSystemId'
    | '/games/$id/dilemmas/'
    | '/games/$id/star-system/$starSystemId/colonization'
    | '/games/$id/star-system/$starSystemId/commission-task-force'
    | '/games/$id/star-system/$starSystemId/industrial-projects'
    | '/games/$id/star-system/$starSystemId/task-forces'
    | '/games/$id/star-system/$starSystemId/task-forces/$taskForceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/features'
    | '/learn'
    | '/signin'
    | '/games'
    | '/games/$id'
    | '/games/$id/research'
    | '/games/$id/ship-designs'
    | '/games/$id/turn-reports'
    | '/games/lobby/$id'
    | '/games/$id/dilemmas/$dilemmaId'
    | '/games/$id/engagement/$engagementId'
    | '/games/$id/ship-designs/new'
    | '/games/$id/star-system/$starSystemId'
    | '/games/$id/dilemmas'
    | '/games/$id/star-system/$starSystemId/colonization'
    | '/games/$id/star-system/$starSystemId/commission-task-force'
    | '/games/$id/star-system/$starSystemId/industrial-projects'
    | '/games/$id/star-system/$starSystemId/task-forces'
    | '/games/$id/star-system/$starSystemId/task-forces/$taskForceId'
  id:
    | '__root__'
    | '/_dashboard'
    | '/_dashboard/_authenticated'
    | '/_dashboard/features'
    | '/_dashboard/learn'
    | '/_dashboard/signin'
    | '/games/_authenticated'
    | '/_dashboard/'
    | '/games/_authenticated/$id'
    | '/games/_authenticated/$id/research'
    | '/games/_authenticated/$id/ship-designs'
    | '/games/_authenticated/$id/turn-reports'
    | '/_dashboard/_authenticated/games/'
    | '/_dashboard/_authenticated/games/lobby/$id'
    | '/games/_authenticated/$id/dilemmas/$dilemmaId'
    | '/games/_authenticated/$id/engagement/$engagementId'
    | '/games/_authenticated/$id/ship-designs/new'
    | '/games/_authenticated/$id/star-system/$starSystemId'
    | '/games/_authenticated/$id/dilemmas/'
    | '/games/_authenticated/$id/star-system/$starSystemId/colonization'
    | '/games/_authenticated/$id/star-system/$starSystemId/commission-task-force'
    | '/games/_authenticated/$id/star-system/$starSystemId/industrial-projects'
    | '/games/_authenticated/$id/star-system/$starSystemId/task-forces'
    | '/games/_authenticated/$id/star-system/$starSystemId/task-forces/$taskForceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  GamesAuthenticatedRoute: typeof GamesAuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/games/_authenticated': {
      id: '/games/_authenticated'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof GamesAuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/signin': {
      id: '/_dashboard/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof DashboardSigninRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/learn': {
      id: '/_dashboard/learn'
      path: '/learn'
      fullPath: '/learn'
      preLoaderRoute: typeof DashboardLearnRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/features': {
      id: '/_dashboard/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof DashboardFeaturesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/_authenticated': {
      id: '/_dashboard/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardAuthenticatedRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/games/_authenticated/$id': {
      id: '/games/_authenticated/$id'
      path: '/$id'
      fullPath: '/games/$id'
      preLoaderRoute: typeof GamesAuthenticatedIdLazyRouteImport
      parentRoute: typeof GamesAuthenticatedRoute
    }
    '/_dashboard/_authenticated/games/': {
      id: '/_dashboard/_authenticated/games/'
      path: '/games'
      fullPath: '/games/'
      preLoaderRoute: typeof DashboardAuthenticatedGamesIndexRouteImport
      parentRoute: typeof DashboardAuthenticatedRoute
    }
    '/games/_authenticated/$id/turn-reports': {
      id: '/games/_authenticated/$id/turn-reports'
      path: '/turn-reports'
      fullPath: '/games/$id/turn-reports'
      preLoaderRoute: typeof GamesAuthenticatedIdTurnReportsLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdLazyRoute
    }
    '/games/_authenticated/$id/ship-designs': {
      id: '/games/_authenticated/$id/ship-designs'
      path: '/ship-designs'
      fullPath: '/games/$id/ship-designs'
      preLoaderRoute: typeof GamesAuthenticatedIdShipDesignsLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdLazyRoute
    }
    '/games/_authenticated/$id/research': {
      id: '/games/_authenticated/$id/research'
      path: '/research'
      fullPath: '/games/$id/research'
      preLoaderRoute: typeof GamesAuthenticatedIdResearchLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdLazyRoute
    }
    '/games/_authenticated/$id/dilemmas/': {
      id: '/games/_authenticated/$id/dilemmas/'
      path: '/dilemmas'
      fullPath: '/games/$id/dilemmas/'
      preLoaderRoute: typeof GamesAuthenticatedIdDilemmasIndexLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdLazyRoute
    }
    '/games/_authenticated/$id/star-system/$starSystemId': {
      id: '/games/_authenticated/$id/star-system/$starSystemId'
      path: '/star-system/$starSystemId'
      fullPath: '/games/$id/star-system/$starSystemId'
      preLoaderRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdLazyRoute
    }
    '/games/_authenticated/$id/ship-designs/new': {
      id: '/games/_authenticated/$id/ship-designs/new'
      path: '/new'
      fullPath: '/games/$id/ship-designs/new'
      preLoaderRoute: typeof GamesAuthenticatedIdShipDesignsNewLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdShipDesignsLazyRoute
    }
    '/games/_authenticated/$id/engagement/$engagementId': {
      id: '/games/_authenticated/$id/engagement/$engagementId'
      path: '/engagement/$engagementId'
      fullPath: '/games/$id/engagement/$engagementId'
      preLoaderRoute: typeof GamesAuthenticatedIdEngagementEngagementIdLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdLazyRoute
    }
    '/games/_authenticated/$id/dilemmas/$dilemmaId': {
      id: '/games/_authenticated/$id/dilemmas/$dilemmaId'
      path: '/dilemmas/$dilemmaId'
      fullPath: '/games/$id/dilemmas/$dilemmaId'
      preLoaderRoute: typeof GamesAuthenticatedIdDilemmasDilemmaIdLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdLazyRoute
    }
    '/_dashboard/_authenticated/games/lobby/$id': {
      id: '/_dashboard/_authenticated/games/lobby/$id'
      path: '/games/lobby/$id'
      fullPath: '/games/lobby/$id'
      preLoaderRoute: typeof DashboardAuthenticatedGamesLobbyIdRouteImport
      parentRoute: typeof DashboardAuthenticatedRoute
    }
    '/games/_authenticated/$id/star-system/$starSystemId/task-forces': {
      id: '/games/_authenticated/$id/star-system/$starSystemId/task-forces'
      path: '/task-forces'
      fullPath: '/games/$id/star-system/$starSystemId/task-forces'
      preLoaderRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute
    }
    '/games/_authenticated/$id/star-system/$starSystemId/industrial-projects': {
      id: '/games/_authenticated/$id/star-system/$starSystemId/industrial-projects'
      path: '/industrial-projects'
      fullPath: '/games/$id/star-system/$starSystemId/industrial-projects'
      preLoaderRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute
    }
    '/games/_authenticated/$id/star-system/$starSystemId/commission-task-force': {
      id: '/games/_authenticated/$id/star-system/$starSystemId/commission-task-force'
      path: '/commission-task-force'
      fullPath: '/games/$id/star-system/$starSystemId/commission-task-force'
      preLoaderRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute
    }
    '/games/_authenticated/$id/star-system/$starSystemId/colonization': {
      id: '/games/_authenticated/$id/star-system/$starSystemId/colonization'
      path: '/colonization'
      fullPath: '/games/$id/star-system/$starSystemId/colonization'
      preLoaderRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute
    }
    '/games/_authenticated/$id/star-system/$starSystemId/task-forces/$taskForceId': {
      id: '/games/_authenticated/$id/star-system/$starSystemId/task-forces/$taskForceId'
      path: '/$taskForceId'
      fullPath: '/games/$id/star-system/$starSystemId/task-forces/$taskForceId'
      preLoaderRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRouteImport
      parentRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRoute
    }
  }
}

interface DashboardAuthenticatedRouteChildren {
  DashboardAuthenticatedGamesIndexRoute: typeof DashboardAuthenticatedGamesIndexRoute
  DashboardAuthenticatedGamesLobbyIdRoute: typeof DashboardAuthenticatedGamesLobbyIdRoute
}

const DashboardAuthenticatedRouteChildren: DashboardAuthenticatedRouteChildren =
  {
    DashboardAuthenticatedGamesIndexRoute:
      DashboardAuthenticatedGamesIndexRoute,
    DashboardAuthenticatedGamesLobbyIdRoute:
      DashboardAuthenticatedGamesLobbyIdRoute,
  }

const DashboardAuthenticatedRouteWithChildren =
  DashboardAuthenticatedRoute._addFileChildren(
    DashboardAuthenticatedRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardAuthenticatedRoute: typeof DashboardAuthenticatedRouteWithChildren
  DashboardFeaturesRoute: typeof DashboardFeaturesRoute
  DashboardLearnRoute: typeof DashboardLearnRoute
  DashboardSigninRoute: typeof DashboardSigninRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAuthenticatedRoute: DashboardAuthenticatedRouteWithChildren,
  DashboardFeaturesRoute: DashboardFeaturesRoute,
  DashboardLearnRoute: DashboardLearnRoute,
  DashboardSigninRoute: DashboardSigninRoute,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface GamesAuthenticatedIdShipDesignsLazyRouteChildren {
  GamesAuthenticatedIdShipDesignsNewLazyRoute: typeof GamesAuthenticatedIdShipDesignsNewLazyRoute
}

const GamesAuthenticatedIdShipDesignsLazyRouteChildren: GamesAuthenticatedIdShipDesignsLazyRouteChildren =
  {
    GamesAuthenticatedIdShipDesignsNewLazyRoute:
      GamesAuthenticatedIdShipDesignsNewLazyRoute,
  }

const GamesAuthenticatedIdShipDesignsLazyRouteWithChildren =
  GamesAuthenticatedIdShipDesignsLazyRoute._addFileChildren(
    GamesAuthenticatedIdShipDesignsLazyRouteChildren,
  )

interface GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteChildren {
  GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRoute
}

const GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteChildren: GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteChildren =
  {
    GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRoute:
      GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesTaskForceIdLazyRoute,
  }

const GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteWithChildren =
  GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRoute._addFileChildren(
    GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteChildren,
  )

interface GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteChildren {
  GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRoute
  GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRoute
  GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRoute
  GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteWithChildren
}

const GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteChildren: GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteChildren =
  {
    GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRoute:
      GamesAuthenticatedIdStarSystemStarSystemIdColonizationLazyRoute,
    GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRoute:
      GamesAuthenticatedIdStarSystemStarSystemIdCommissionTaskForceLazyRoute,
    GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRoute:
      GamesAuthenticatedIdStarSystemStarSystemIdIndustrialProjectsLazyRoute,
    GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRoute:
      GamesAuthenticatedIdStarSystemStarSystemIdTaskForcesLazyRouteWithChildren,
  }

const GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteWithChildren =
  GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute._addFileChildren(
    GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteChildren,
  )

interface GamesAuthenticatedIdLazyRouteChildren {
  GamesAuthenticatedIdResearchLazyRoute: typeof GamesAuthenticatedIdResearchLazyRoute
  GamesAuthenticatedIdShipDesignsLazyRoute: typeof GamesAuthenticatedIdShipDesignsLazyRouteWithChildren
  GamesAuthenticatedIdTurnReportsLazyRoute: typeof GamesAuthenticatedIdTurnReportsLazyRoute
  GamesAuthenticatedIdDilemmasDilemmaIdLazyRoute: typeof GamesAuthenticatedIdDilemmasDilemmaIdLazyRoute
  GamesAuthenticatedIdEngagementEngagementIdLazyRoute: typeof GamesAuthenticatedIdEngagementEngagementIdLazyRoute
  GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute: typeof GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteWithChildren
  GamesAuthenticatedIdDilemmasIndexLazyRoute: typeof GamesAuthenticatedIdDilemmasIndexLazyRoute
}

const GamesAuthenticatedIdLazyRouteChildren: GamesAuthenticatedIdLazyRouteChildren =
  {
    GamesAuthenticatedIdResearchLazyRoute:
      GamesAuthenticatedIdResearchLazyRoute,
    GamesAuthenticatedIdShipDesignsLazyRoute:
      GamesAuthenticatedIdShipDesignsLazyRouteWithChildren,
    GamesAuthenticatedIdTurnReportsLazyRoute:
      GamesAuthenticatedIdTurnReportsLazyRoute,
    GamesAuthenticatedIdDilemmasDilemmaIdLazyRoute:
      GamesAuthenticatedIdDilemmasDilemmaIdLazyRoute,
    GamesAuthenticatedIdEngagementEngagementIdLazyRoute:
      GamesAuthenticatedIdEngagementEngagementIdLazyRoute,
    GamesAuthenticatedIdStarSystemStarSystemIdLazyRoute:
      GamesAuthenticatedIdStarSystemStarSystemIdLazyRouteWithChildren,
    GamesAuthenticatedIdDilemmasIndexLazyRoute:
      GamesAuthenticatedIdDilemmasIndexLazyRoute,
  }

const GamesAuthenticatedIdLazyRouteWithChildren =
  GamesAuthenticatedIdLazyRoute._addFileChildren(
    GamesAuthenticatedIdLazyRouteChildren,
  )

interface GamesAuthenticatedRouteChildren {
  GamesAuthenticatedIdLazyRoute: typeof GamesAuthenticatedIdLazyRouteWithChildren
}

const GamesAuthenticatedRouteChildren: GamesAuthenticatedRouteChildren = {
  GamesAuthenticatedIdLazyRoute: GamesAuthenticatedIdLazyRouteWithChildren,
}

const GamesAuthenticatedRouteWithChildren =
  GamesAuthenticatedRoute._addFileChildren(GamesAuthenticatedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  GamesAuthenticatedRoute: GamesAuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
